import { IExportColumnModel } from "../../../../shared/models";

export const ConnectionsColumnList: IExportColumnModel[] = [
]